<!--
 * @Author: Merlin
 * @Date: 2023-12-01 15:44:20
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-08 19:15:45
 * @Description: 
-->
<template>
    <div class="count-down-wrap" v-if="iCount > -1">
        <h3 class="title counted" v-if="iCount < 1">
            {{ $t('crash.go')}}
        </h3>
        <template v-else>
            <h3 class="title couting">
                {{ $t('crash.startIn')}} {{ '0' + iCount }}
            </h3>    
            <div class="bar-wrap" >
                <span class="bar-inner"></span>
            </div>
            <p class="get-bet" >
                {{ $t('crash.getting_the_bests')}}
            </p>
        </template>
    </div>
</template>

<script setup>
const iCount = ref(5);
let unmounted = false;

init();
async function init(){
    let iStepLong = 200;
    let iPastMS = 0;
    iCount.value = 5;
    for (const idx of Array(60).keys()){
        await Sleep(iStepLong); 
        iPastMS += iStepLong;
        let iPastSec = ~~(iPastMS / 700);
        iCount.value = 5 - iPastSec;
        if ((iCount.value <= -1) || unmounted){
            return;
        }
    }
}

onBeforeUnmount(()=>{
    unmounted = true;
});
</script>

<style lang="scss" scoped>
.count-down-wrap{
    // width: 17rem;
    display: flex;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    color: white;
}

.title{
    // height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    line-height: 1.5;
    font-weight: 700;
    font-size: 26px;
    font-weight: 700;
    white-space: nowrap;
    &[class ~= counted]{
        font-size: 36px;
    }
}

.bar-wrap{
    // width: 15rem;
    width: 100%;
    margin: 0 1rem;
    height: 3px;
    margin: 0 auto 10px;
    background: rgba(255,255,255, 0.3);
    border-radius: 2px;
    overflow: hidden;
}

@keyframes goShorter{
    0%{
        transform: translateX(0);
    }
    100%{
        transform: translateX(-101%);
    }
}

.bar-inner{
    display: block;
    width: 100%;
    height: 100%;
    transform: translateX(0);
    will-change: transform;
    animation: goShorter 4s linear 0s 1 normal forwards;
    background: white;
}
.get-bet{
    font-size: 14px;
    font-weight: 600;
    color: #ffffffdb;
}

</style>

